import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyle = makeStyles((theme) => ({
  status: {
    textTransform: 'uppercase',
    fontWeight: 800,
    maxWidth: 100,
  },
  statusCell: {
    '&.paid, &.negociated': {
      color: '#4CAF50',
    },
    '&.refunded, &.waiting_refund': {
      color: theme.palette.error.main,
    },
    '&.canceled, &.duplicated, &.expired': {
      color: '#37474F',
    },
    '&.open, &.waiting_payment': {
      color: '#039BE5',
    },
    '&.analysing': {
      color: '#2d86ca',
    },
    '&.recovering': {
      color: '#fabb0a',
    },
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      '& p': {
        marginRight: 8,
      },
    },
  },
}));

export default useStyle;
